/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useEffect, useState, useCallback } from "react"

// react-router-dom components
import { useHistory } from 'react-router-dom';
import { setupUser, getUser } from 'discordAPI'


// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgSignIn from "assets/images/nebula.jpg";

function SignIn() {
    const [error, setError] = useState([]);
    const history = useHistory();
    const [isLoggingIn, setIsLoggingIn] = useState(true);

    const getUserDetails = useCallback(async (accessToken, tokenType) => {
        setError('');
        try {
            if (accessToken) {
                setupUser(accessToken, tokenType)
                    .then((result) => {
                        history.push('/dashboard');
                    },
                        (error) => {
                            setIsLoggingIn(false);
                            setError(error);
                        });
            }
            else {
                getUser()
                    .then((result) => {
                        history.push('/dashboard');
                    },
                        (error) => {
                            setIsLoggingIn(false);
                        });
            }
        } catch (err) {
            setError(err.message);
            setIsLoggingIn(false);
        }
    }, []);


    useEffect(() => {
        setIsLoggingIn(true);
        const fragment = new URLSearchParams(window.location.hash.slice(1));
        const [accessToken, tokenType, expiresin] = [
            fragment.get("access_token"),
            fragment.get("token_type"),
            fragment.get("expires_in")
        ];
        getUserDetails(accessToken, tokenType);
    }, [getUserDetails]);

    return (
        <CoverLayout
            title="PᏒIM&#43612;ᏒDIΛLS Management"
            color="white"
            description="Please login with your Discord account to access the PᏒIM&#43612;ᏒDIΛLS system"
            premotto=""
            motto=""
            image={bgSignIn}
        >
            {!isLoggingIn ? (
                <VuiBox align="center">
                    <VuiButton
                        color="info"
                        component="a"
                        href="https://discord.com/api/oauth2/authorize?client_id=979657578172792842&redirect_uri=https%3A%2F%2Fprimordials.live%2Fauthentication%2Fsign-in&response_type=token&scope=identify%20guilds.members.read"
                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                        Login with Discord
                    </VuiButton>
                </VuiBox>
                ) : (
                    <VuiBox align="center">
                        <VuiTypography  variant="h4" color="text" fontWeight="medium">
                            Logging in to system
                        </VuiTypography>
                    </VuiBox>
                )
            }

            <VuiBox align="center">
                <VuiTypography color="error" variant="button" fontWeight="medium">
                    {error}
                </VuiTypography>
            </VuiBox>
        </CoverLayout>
  );
}

export default SignIn;
